import { NavLink, Outlet } from 'react-router-dom';

const mastersSections = [
  { to: 'locations',             label: 'Locations' },
  { to: 'users',                 label: 'Users' },
  { to: 'merchant-exporters',    label: 'Merchant Exporters' },
  { to: 'ppcs',                  label: 'Third-Party PPCs' },
  { to: 'products',              label: 'Products / Species' },
  { to: 'customers',             label: 'Customers' },
  { to: 'ports',                 label: 'Export Ports' },
  { to: 'suppliers',             label: 'Suppliers' },
  { to: 'purchase-centers',      label: 'Purchase Centers' },
  { to: 'fcodes',                label: 'F Codes (Lot No.)' },
  { to: 'approval-thresholds',   label: 'Approval Thresholds' },
  { to: 'notification-settings', label: 'Notification Settings' },
];

export default function MastersPage() {
  return (
    <div className="flex gap-6 h-full">
      {/* Left nav */}
      <aside className="w-52 flex-shrink-0">
        <nav className="space-y-0.5">
          {mastersSections.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `block px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-navy-600 text-white'
                    : 'text-gray-600 hover:bg-gray-100'
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
